import Button from './Button';
import Container from './Container';
const OAuth = Object.assign(({}), { Container, Button });
export default OAuth;
